module.exports = __webpack_public_path__ + "img/sample-02.bee52d9b.png";